import {useProjects} from "../Behaviors/projects";
import { ProjectState, getProjectState } from "../Behaviors/projectTools";
import { useStore } from "../State/zustandStore";
import { useJob } from "../Behaviors/ingest.api";
import { ProjectType } from "../api";
import {DraftView} from "./Views/Drafts/DraftView";
import { UploadingView } from "./Views/UploadingView";
import { InProgressView } from "./Views/InProgressView";
import { CompletedView } from "./Views/CompletedView";
import { NeedAttentionView } from "./Views/NeedAttentionView";

export const ProjectView = () => {
    const workspaceState = useStore().projects;
    const {project} = useProjects(workspaceState.selectedProjectId);
    const job = useJob(project?.jobId);
    let header = "";

    switch(project?.projectType) {
    case ProjectType.Release:
        header = "Product Info";
        break;
    case ProjectType.Resource:
        header = "Resource Info";
        break;
    }

    if (workspaceState.selectedProjectId && !project) {
        return <DraftView header={header} />;
    }

    if (project) {
        let state = job ? getProjectState(job!) : ProjectState.Draft;

        if (project.resources?.filter(r => !r.deleted).find(r => r.uploadError)) {
            state = ProjectState.NeedsAttention;
        }

        switch (state) {
        case ProjectState.Draft:
            return project.isIngestRequestedAfterUpload === true
                ? (<UploadingView header={header} />)
                : (<DraftView header={header} />);
        case ProjectState.Processing:
            return (<InProgressView header={header} />);
        case ProjectState.Completed:
            return (<CompletedView header={header} />);
        case ProjectState.NeedsAttention:
            return (<NeedAttentionView header={header} />);
        }
        return (<div> Unknown project state: {state}</div>);
    }
    return (<div> No Job Selected</div>);

};
